import {NotificationItemData} from 'platform/components';

import {isNil} from 'ramda';

import {User} from '@dms/api/core';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

/**
 * Marks a notification that reached the current user because they are someone else's delegate.
 *
 * The item data arrives in three shapes - a resolved item, a pending one, or `null` for a
 * notification type the app does not render. `null` has to stay `null`: `NotificationsWidget`
 * filters the nullish items out before it awaits the rest, so a promise wrapped around `null`
 * would slip past that filter and reach the notification center.
 */
export const addDelegatedForFlag = (
  itemData: Promise<NotificationItemData> | NotificationItemData | null,
  delegatedFor: User | Nullish
) => {
  if (isNil(itemData)) {
    return null;
  }

  return Promise.resolve(itemData).then((item) => {
    if (isNil(delegatedFor)) {
      return item;
    }

    const flags: NotificationItemData['flags'] = [
      ...(item.flags ?? []),
      {
        label: i18n.t('general.notifications.labels.delegatedFor', {userName: delegatedFor.name}),
        colorScheme: 'blue',
        isSubtle: true,
        'data-testid': 'delegatedForFlag',
      },
    ];

    return {...item, flags};
  });
};
